import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";
import { MessageBox } from "element-ui";
export const Manage_internet_service = {
    getAll,
    add_promotion,
    editPromotion,
    deletePromotion,
    get_provider_id,
    get_user_info,
    getPromotionById,
    analyzeFile,
    insertFromFile,
    getHistory,
    findPromotion,
    searchPopularPromotion,
    setObjPdf,
    getMonthlyRegulate,
    getRecentMissingRow,
    setUnlinkFile,
    getCurrentMonthlyRegulate,
    removeMonthlyRegulate,
    downloadMonthlyRegulate,
    exportMonthlyRegulate,
    getAvailableMonthlyRegulate,
    getPromotionByRevision
}


function add_promotion(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/addPromotion/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function editPromotion(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    data.admin_id = json_cookie.admin_id
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/editPromotion/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function get_provider_id() {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/getProviderId/?authorization=" + json_cookie.token, { admin_id: json_cookie.admin_id })
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function get_user_info() {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "manage_internet/getUserInfo/" + json_cookie.admin_id + "?authorization=" + json_cookie.token, { params: json_cookie.admin_id })
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getAll(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/getAll/?authorization=" + json_cookie.token, { queryInfo: data })
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getPromotionById(id) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "manage_internet/getPromotionById/" + id + "?authorization=" + json_cookie.token, { id: id })
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function deletePromotion(row_info) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/deletePromotion/?authorization=" + json_cookie.token, row_info)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getHistory(params) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "manage_internet/getHistory/?authorization=" + json_cookie.token, { params: params })
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function findPromotion(params) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "manage_internet/findPromotion/?authorization=" + json_cookie.token, { params: params })
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function searchPopularPromotion(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/searchPopularPromotion/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function analyzeFile(filedata) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/analyzeFile/?authorization=" + json_cookie.token, filedata)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function setObjPdf(filedata) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/setObjPdf/?authorization=" + json_cookie.token, filedata)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function insertFromFile(params) {
    let json_cookie = JSON.parse(Cookie.get('user_nbtc'))
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/insertFromFile/?authorization=" + json_cookie.token, params)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getMonthlyRegulate(params) {
    let json_cookie = JSON.parse(Cookie.get('user_nbtc'))
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "manage_internet/getMonthlyRegulate/?authorization=" + json_cookie.token, { params: params })
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getRecentMissingRow(params) {
    let json_cookie = JSON.parse(Cookie.get('user_nbtc'))
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "manage_internet/getRecentMissingRow/?authorization=" + json_cookie.token, { params: params })
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function setUnlinkFile(params){
    let json_cookie = JSON.parse(Cookie.get('user_nbtc'))
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/setUnlinkFile/?authorization=" + json_cookie.token, {filepath : params})
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })    
    })
}

function getCurrentMonthlyRegulate(filter) {
    let json_cookie = JSON.parse(Cookie.get('user_nbtc'))
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/getCurrentMonthlyRegulate/?authorization=" + json_cookie.token, filter)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function removeMonthlyRegulate(iteminfo){
    let json_cookie = JSON.parse(Cookie.get('user_nbtc'))
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/removeMonthlyRegulate/?authorization=" + json_cookie.token, iteminfo)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function downloadMonthlyRegulate(filepath){
    let json_cookie = JSON.parse(Cookie.get('user_nbtc'))
    const forceFileDownload = (response,filename)=>{
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
    }
    axios({
        method: 'get',
        url: config.API_URL + "checkRouter/download/?authorization=" + json_cookie.token,
        responseType: 'arraybuffer',
        params : { 'filename' : filepath }
    })
    .then(response => {
        var split = filepath.split('/')
        forceFileDownload(response, split[2])
    })
    .catch(() => MessageBox.confirm('ไม่พบไฟล์ที่ต้องการดาวน์โหลด', 'แจ้งเตือน', {
        confirmButtonText: 'ตกลง',
        showCancelButton: false,
        type: 'warning'
    }))
}

function exportMonthlyRegulate(formdata){
    let json_cookie = JSON.parse(Cookie.get('user_nbtc'))
    const forceFileDownload = (response,filename)=>{
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
    }
    axios({
        method: 'post',
        url: config.API_URL + "checkRouter/export/?authorization=" + json_cookie.token,
        data : formdata,
        responseType: 'arraybuffer',
    })
    .then(response => {
        var filename = formdata.monthly_regulate.split('/').join('-')+'-'+Date.now()+'.xlsx'
        forceFileDownload(response, filename)
    })
    .catch(() => MessageBox.confirm('ไม่พบไฟล์ที่ต้องการดาวน์โหลด', 'แจ้งเตือน', {
        confirmButtonText: 'ตกลง',
        showCancelButton: false,
        type: 'warning'
    }))
}

function getAvailableMonthlyRegulate(provider_id){
    let json_cookie = JSON.parse(Cookie.get('user_nbtc'))
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/getAvailableMonthlyRegulate/?authorization=" + json_cookie.token, provider_id)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getPromotionByRevision(data){
    let json_cookie = JSON.parse(Cookie.get('user_nbtc'))
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_internet/getPromotionByRevision/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}